export class SimpleCache {
    cache = {};
    minutes = 30;

    constructor(mins = 30) {
        this.minutes = mins;
    }

    cacheDate() {
        const dt = new Date();
        dt.setMinutes(dt.getMinutes() + this.minutes);
        return dt;
    }

    get(key: string) {
        if (this.cache[key] && this.cache[key].until >= new Date()) {
            return this.cache[key].data;
        }
        return null;
    }

    set(key: string, data) {
        this.cache[key] = { until: this.cacheDate(), data: data };
    }

    remove(key: string) {
        this.cache[key] = null;
    }
}
